<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">居民互动</div>
      </div>
    </div>
    <div class="section">
      <div class="biaodan2">
        <div class="biaodan-left">
          <div style="height: 100%; width: 100%;display: flex;align-items: center;">
            <el-form
              :inline="true"
              label-position="left"
              :model="form"
            >
              <el-form-item label="问卷标题">
                <el-input
                  v-model="form.title"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="问卷类型">
                <el-select
                  style="width: 356px;"
                  v-model="form.linkType"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in typeList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属部门">
                <el-select
                  style="width: 356px;"
                  v-model="form.deptCode"
                  placeholder="请选择"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in deptList"
                    :key="index"
                    :label="item.deptName"
                    :value="item.deptCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发布状态">
                <el-select
                  style="width: 356px;"
                  v-model="form.state"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in stateList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form-item">
                <el-button @click="onSearch" class="search">查询</el-button>
                <el-button @click="onReset" class="reset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div style="display: flex;align-items: center;justify-content: flex-end;margin-bottom: 10px;">
            <el-button
              @click="openIssuesDialogFun()"
              class="search el-icon-plus"
              >新增</el-button
            >
          </div>
        </div>
      </div>
      <div class="aside">
        <common-table
          :maxHeight="550"
          :page="page"
          :dataList="dataList"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        >
          <template v-slot:state="{ scope }">
            <el-switch v-model="scope.row.checked" @change="changeItem(scope.row)"></el-switch>
            <span>{{ scope.row.checked ? '已发布' : '未发布' }}</span>
          </template>
          <template v-slot:operation="{ scope }">
            <!-- <el-button
              @click="openIssuesDialogFun(scope.row)"
              style="color: #0090ff; font-size: 16px"
              type="text"
              >编辑</el-button
            > -->
            <el-button
              @click="delEventEditFun(scope.row.id)"
              style="color: #eb3538; font-size: 16px"
              type="text"
              >删除</el-button
            >
          </template>
        </common-table>
      </div>
    </div>

    <!-- 新增/编辑指标 -->
    <issuesDialog
      v-if="issuesDialogVisible"
      @refreshList="eventPageFun"
      :dialogVisible.sync="issuesDialogVisible"
      :curItem="issuesCurItem"
      :typeList="typeList"
    >
    </issuesDialog>
  </div>
</template>
<script>
import {
  wenjuancrateOrUpdate,
  wenjuanpage,
  wenjuandel
} from "@/api/base.js";
import {
  authUserDeptList
} from "@/api/task.js";
import {
  getCommcommunityAll,
} from "@/api/point.js";
import commonTable from "@/components/table/index.vue";
import issuesDialog from "./components/issuesDialog.vue";
export default {
  components: {
    commonTable,
    issuesDialog,
  },
  data() {
    return {
      form: {
        title: "",
        linkType: "",
        state: "",
        deptCode: "",
      },
      issuesDialogVisible: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "title",
            label: "问卷标题"
          },
          {
            prop: "linkType",
            label: "问卷类型"
          },
          {
            prop: "link",
            label: "问卷链接",
            width: '300px'
          },
          
          {
            slot: "state",
            label: "发布状态"
          },
          {
            prop: "deptName",
            label: "所属部门"
          },
          {
            prop: "createUsername",
            label: "创建人"
          },
          {
            prop: "updateTime",
            label: "更新时间",
            width: '200px'
          },
          {
            slot: "operation",
            label: "操作",
          }
        ]
      },
      issuesCurItem: {},
      typeList: [
        {
          id: '满意度调查',
          name: '满意度调查'
        },
        {
          id: '学习答题',
          name: '学习答题'
        }
      ],
      stateList: [
        {
          id: '未发布',
          name: '未发布'
        },
        {
          id: '已发布',
          name: '已发布'
        }
      ],
      deptList: []
    };
  },
  async mounted() {
    await this.authUserDeptListFun();
    await this.onSearch();
  },
  methods: {
    // 获取部门资源树形
    async authUserDeptListFun() {
      let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
      if (userInfo.roles.map(item => item.roleCode).includes('GLLD')) {
        let params = {
          notEndStr: '网格',
          noAuthFlag: true
        };
        const res = await authUserDeptList(params);
        this.deptList = res.data.data;
      } else {
        let res = await getCommcommunityAll();
        if (res.data.code == 200) {
          let actionsData = res.data.data.map((item) => ({
            deptName: item.pointName,
            deptCode: item.deptCode,
          }));
          let depcode = JSON.parse(
            sessionStorage.getItem("userInfo")
          ).detpCode;
          // let depcode = "4403260050232323";
          if (depcode.length < 12) {
            // this.deptList = JSON.parse(JSON.stringify(actionsData));
            this.deptList = [];
            this.form.deptCode = userInfo.deptId;
            this.deptList.push({
              deptCode: userInfo.deptId,
              deptName: userInfo.deptName
            })
          } else {
            let code = depcode.slice(0, 12);
            this.deptList = actionsData.filter(
              (item) => item.deptCode == code
            );
            if (this.deptList.length) {
              this.form.deptCode = this.deptList[0].deptCode;
            } else {
              this.deptList = [];
              this.form.deptCode = userInfo.deptId;
              this.deptList.push({
                deptCode: userInfo.deptId,
                deptName: userInfo.deptName
              })
            }
          }
        }
      }
    },
    openIssuesDialogFun(item) {
      this.issuesDialogVisible = true;
      this.issuesCurItem = {
        editType: item ? "edit" : "add",
        ...item,
      };
      if (!item) {
        this.issuesCurItem.id = "";
      }
      // console.log(JSON.parse(JSON.stringify(this.issuesCurItem)))
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.eventPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.eventPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.eventPageFun();
    },
    onReset() {
      this.form = this.$options.data().form;
      this.page.page = 1;
      this.page.size = 10;
      this.eventPageFun();
    },
    async delEventEditFun(id) {
      console.log(id)
      this.$confirm("是否删除该数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(async () => {
        const res = await wenjuandel({
          id: id
        });
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: "删除成功"
          });
          this.eventPageFun();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg
          });
        }
      })
    },
    async changeItem (item) {
      await wenjuancrateOrUpdate({
        id: item.id,
        state: item.checked ? '已发布' : '未发布'
      })
      this.eventPageFun();
    },
    // 分页查询
    async eventPageFun() {
      let params = {
        ...this.form,
        page: this.page.page,
        size: this.page.size,
      };
      const res = await wenjuanpage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        if (this.dataList.tableData.length) {
          this.dataList.tableData.forEach(item => item.checked = item.state == '已发布' ? true : false)
        }
        this.page.total = res.data.data.total;
      }
    }
  },
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.box-father {
  .section {
    display: flex;
    flex-direction: column;
    padding: 20px;

    .left {
      width: 20%;
      height: 100%;
      overflow: auto;
      padding: 28px 24px;
      border-right: 1px solid #e0e0e0;
    }

    .right {
      width: 80%;
      height: 100%;
      padding: 28px 24px;
    }

    .title {
      font-family: MiSans, MiSans;
      font-weight: 700;
      font-size: 20px;
      color: #494c4f;
      margin-bottom: 12px;
    }
  }
}

.search-box {
  display: flex;
  margin-bottom: 12px;
}

.type-list {
  height: calc(100vh - 300px);
  overflow: auto;

  .type-list-item {
    width: 100%;
    // height: 94px;
    padding: 12px;
    background: #f7faff;
    border-radius: 4px;
    margin-bottom: 12px;
    cursor: pointer;

    .item-top {
      display: flex;
      align-items: center;

      .name {
        flex: 1;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 18px;
        color: #494c4f;
      }

      .type {
        background: rgba(0, 144, 255, 0.1);
        border-radius: 2px;
        padding: 1px 6px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 16px;
        color: #0090ff;
        margin: 0 0 6px 0;
      }
    }

    .item-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .edit {
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  .type-list-item.active {
    border: 1px solid #3caaff;
    background: #f7faff url("~@/assets/image/active.png") center no-repeat;
    background-size: 100% 100%;
    border-radius: 8px;
  }
}
.box {
  display: flex;
}
.box-wrap {
  flex-wrap: wrap;
}
.img-item {
  width: 110px;
  height: 110px;
  border-radius: 8px;
  margin: 0 8px 8px 0;
  position: relative;
  img {
    border-radius: 8px;
    width: 100%;
    height: 100%;
  }
  span {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.4);
    color: #FFFFFF;
    font-size: 13px;
    font-weight: 400;
    padding: 2px 0;
    border-radius: 0 0 8px 8px;
    text-align: center;
  }
}

.mt-20 {
  margin-top: 20px;
}

.pt-20 {
  padding-top: 20px;
}

.border-top {
  border-top: 1px solid #EEEEEE;
}
</style>



// WEBPACK FOOTER //
// src/pages/jmhd/index.vue